import { Dropdown, Icon, Menu } from 'antd';
import React, { memo, useMemo } from 'react';
import cn from 'classnames';
import getName from '../../helpers/getName.js';
import DispexButton from '../DispexButton/DispexButton';
import styles from './DropdownButton.module.scss';

const DropdownButton = ({
  text,
  options,
  overlay,
  prevText,
  disabled,
  onOptionSelected,
  buttonType,
  className,
  buttonClassName,
  onDeselt,
  clearable = false,
  clearOptionText,
  deletable,
  onDeleteItem,
  clearOptionDisabled = false,
  getPopupContainer = () => document.body,
  invert,
}) => {
  const menu = useMemo(() => {
    if (options) {
      return (
        <Menu>
          {options?.map((option) => {
            return (
              <Menu.Item
                value={option}
                onClick={(e) => onOptionSelected(e, option)}
                key={option.id}
                className={styles.item}
              >
                <span>{getName(option)}</span>
                {deletable && (
                  <Icon
                    type="delete"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDeleteItem(e, option);
                    }}
                  />
                )}
              </Menu.Item>
            );
          })}
          {clearable && (
            <Menu.Item
              disabled={clearOptionDisabled}
              key={'null'}
              value={null}
              onClick={onDeselt}
            >
              {clearOptionText || 'Все'}
            </Menu.Item>
          )}
        </Menu>
      );
    }
  }, [
    options,
    onOptionSelected,
    onDeleteItem,
    deletable,
    clearable,
    clearOptionText,
    onDeselt,
    clearOptionDisabled,
  ]);

  return (
    <div className={cn(styles.container, className)}>
      {prevText && <span className={styles.text}>{prevText}</span>}
      <Dropdown
        getPopupContainer={getPopupContainer}
        overlay={overlay || menu}
        disabled={disabled}
        overlayClassName={styles.dropdown}
      >
        <DispexButton
          type={buttonType || 'secondary'}
          className={buttonClassName}
          invert={invert}
        >
          {text}
          <Icon type="caret-down" />
        </DispexButton>
      </Dropdown>
    </div>
  );
};

export default memo(DropdownButton);
